export default {
  methods: {
    isApi(api) {
      return api.apiId !== undefined;
    },

    isExploration(api) {
      return api.ExternalSurveyId !== undefined && api.type === "EXPLORATION";
    },

    isNonExploration(api) {
      return api.ExternalSurveyId !== undefined && api.type === "NONEXPLORATION";
    }
  }
}
